<template>
  <div class="h-[276px] w-full rounded-xl border-2 border-neutral-200 bg-background flex justify-center items-center">
    <slot />
  </div>
</template>
